module.exports = __webpack_public_path__ + "img/empty.c02ff02a.png";